export const GROUP_ROUTES = {
	GROUPS: "/groups",
	LEGACY_DISCOVER: "/groups/discover",
} as const;
